var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.cardId}},[_c('Card',{style:(_vm.cardStyle),attrs:{"padding":_vm.padding}},[(_vm.title.length > 0)?_c('div',{staticClass:"card-title pull-left clearfix",staticStyle:{"padding":"5px 10px"},attrs:{"slot":"title"},slot:"title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/go-card.vue